import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import DutchTaxAdvantage from "./sections/DutchTaxAdvantage";
import Get1020QualifiedRoofingLeadsEveryWeek from "./sections/Get1020QualifiedRoofingLeadsEveryWeek";
import QualityAssured from "./sections/QualityAssured";
import WhyChooseVickyTraders from "./sections/WhyChooseVickyTraders";
import TheAgileBlueprint from "./sections/TheAgileBlueprint";
import OurAchievements from "./sections/OurAchievements";
import ReadyForADeviceUpgrade from "./sections/ReadyForADeviceUpgrade";
import Footer from "@/reusable_sections/Footer";
import EmpoweringImpactThroughEvidence from "./sections/EmpoweringImpactThroughEvidence";
export default function HomePage() {
  return <div>
      <Header />
      <EmpoweringImpactThroughEvidence />
      <DutchTaxAdvantage />
      <Get1020QualifiedRoofingLeadsEveryWeek />
      <QualityAssured />
      <WhyChooseVickyTraders />
      <TheAgileBlueprint />
      <OurAchievements />
      <ReadyForADeviceUpgrade />
      <Footer />
    </div>;
}